import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "./admin/AdminSidebar";

// Sidebar portal class assistant — tampilan sama dengan dashboard Attendance
// milik admin (admin/AdminSidebar.js), hanya menunya lebih sedikit dan tidak
// ada tombol "Switch to Main".
const ITEMS = [
  { path: "/assistant/sessions", label: "Class Sessions", icon: "bi-calendar3" },
  { path: "/assistant/grid", label: "Attendance Grid", icon: "bi-grid-3x3" },
];

const SidebarAssistant = ({ isMobileAdmin }) => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      await axios.delete("/assistant/logout");
    } catch (error) {
    } finally {
      navigate("/assistant/login");
    }
  };

  return <AdminSidebar items={ITEMS} variant="assistant" onLogout={logout} isMobileAdmin={isMobileAdmin} />;
};

export default SidebarAssistant;
